import Vue from 'vue';
import store from 'store';
import { A11y, Keyboard } from 'swiper/modules';

export default (el) =>
  new Vue({
    el,
    store,
    components: {
      'product-card': () => import('../product-card/product-card.vue'),
      'product-card-slider-swiper': () =>
        import('../product-card-slider-swiper/product-card-slider-swiper.vue'),
    },
    data: () => ({
      swiperOptions: {
        slidesPerView: 'auto',
        keyboard: true,
        modules: [Keyboard, A11y]
      },
    }),
    name: 'Product Slider',
    mounted() {},
    methods: {},
  });
